<template>

  <div>

    <br/>
    <h5 data-v-87d86238="" class="pageTitle">Section membre</h5>
    <div style="width: 100%; text-align: center;">
      <button type="button" @click="openUpdatePasswordModal" class="btn btn-primary " style="font-size: 12px;">
        Modifier mon mot de passe
      </button>
    </div>

    <template v-if="subscription">
      <b-row>
        <b-col>
          <subscription-info :ref="'subscription'"/>
        </b-col>
        <b-col cols="5" v-if="!$refs.subscription || $refs.subscription.renewSubscription === false">
          <member-address/>
        </b-col>
      </b-row>
    </template>
    <template v-else>
      <b-row>
        <b-col>
          <subscription-info/>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <member-address/>
        </b-col>
      </b-row>
    </template>

    <template v-if="subscription">

      <members-list/>

      <member-bulletins-list v-if="activeSubscription()"/>

      <membre-conference />

      <membre-don />

      <member-orders-list/>

    </template>

  </div>
</template>

<script>
  import config from '../config';
  import { mapState, mapActions, mapGetters } from 'vuex';
  import SubscriptionInfo from '../components/Membres/Adhesion_Information';
  import MembersList from '../components/Membres/Membres_Liste';
  import MemberOrdersList from '../components/Membres/Factures_Liste';
  import MemberBulletinsList from '../components/Membres/Bulletins_Liste';
  import MemberAddress from '../components/Membres/Membre_Adresse';
  import ChangeUserPassword from '@/components/Utilisateurs/Utilisateur_Modifier_Mot_de_passe';
  import _ from 'lodash';
  import moment from 'moment';
  import MembreConference from "@/components/Membres/Membre_Conferences";
  import MembreDon from "@/components/Membres/Membre_Don.vue";

  export default {
    name: 'MembersSection',
    components: {
      MembreDon,
      MembreConference,
      MemberAddress,
      MemberBulletinsList,
      MemberOrdersList,
      MembersList,
      SubscriptionInfo
    },
    data() {
      return {
        currentSubscription: null,
        canRenew: false,
        isExpired: false,
        updateUserInformations: false,
        config
      };
    },
    async mounted() {
      await this._userRefresh();
      await this.retrieveConferences();

      this.getAllBulletins();
      this.getAllMembers();
      const endMembershipDate = this.userInfos.membershipExpirationDate;

      /**
       * Check si la date de membership est expirée
       */
      if (this.$moment(endMembershipDate).isBefore(this.$moment())) {
        this.isExpired = true;
        this.canRenew = true;
      }

      /**
       * Check si la date de membership expire dans moins de 90 jours
       */
      if (
        this.$moment()
          .add(90, 'days')
          .isAfter(this.$moment(endMembershipDate))
      ) {
        this.canRenew = true;
      }
    },
    computed: {
      ...mapState({
        orders: state => state.orders.all,
        userInfos: state => state.account.user.infos,
        subscriptions: state => state.subscriptions.all,
        cart: state => state.cart.all.items,
        bulletins: state => state.bulletins.all,
        conferences: state => state.members.conferences
      }),
      ...mapGetters('account', {
        getUserInfos: 'getUserInfos'
      }),
      sortedBulletins() {
        return _.orderBy(this.bulletins, [ 'year' ], [ 'desc' ]);
      },
      subscription() {
        const user = this.getUserInfos;
        if (user && user.subscription) {
          return user.subscription; // user.subscription;
        }
        return null;
      }
    },
    methods: {
      ...mapActions('orders', {
        getAllOrders: 'getOrders'
      }),
      ...mapActions('bulletins', {
        getAllBulletins: 'getAll'
      }),
      ...mapActions('account', {
        updateAccount: 'updateInfos',
        _userRefresh: 'refresh'
      }),
      ...mapActions('members', {
        getAllMembers: 'fetchMembers',
        retrieveConferences: 'conferenceToCome'
      }),

      /**
       * Check if the subscription of the member is active.
       *
       * @returns {boolean}
       */
      activeSubscription() {
        if (this.subscription && this.subscription.endDate) {
          const date = moment(this.subscription.endDate);
          if (date.isValid()) {
            return date.isAfter(moment());
          }
        }
        return false;
      },

      async openUpdatePasswordModal() {
        this.$modal.show(ChangeUserPassword, {},
                         {
                           height: 'auto',
                           minHeight: 300,
                           name: 'change-user-password-modal',
                           root: this.$root
                         });
      },

      /**
       * Fonction pour ajouter son renouvellement au panier
       * Si l'utilisateur choisit un autre abonnement, on le redirige vers le formulaire de renouvellement
       * @returns {Promise<void>}
       */
      async renewSubscription() {
        if (
          this.cart.length &&
          !this._.isUndefined(
            this._.find(this.cart, function(item) {
              return item.type === 'renew';
            })
          )
        ) {
          this.$swal({
            type: 'error',
            text: 'Il y a déjà un renouvellement dans votre panier',
            showCloseButton: true,
            confirmButtonText: 'Fermer'
          });
          return;
        }

        const self = this;

        const { value: type } = await this.$swal({
          title: "Quel type d'abonnement voulez-vous?",
          input: 'radio',
          inputOptions: {
            same: "Le même que j'ai actuellement",
            other: "Un autre type d'abonnement"
          },
          inputValidator: value => {
            return !value && 'Vous devez sélectionner un choix de réponse';
          },
          showCloseButton: true,
          showCancelButton: true,
          cancelButtonText: 'Annuler'
        });

        if (type) {
          if (type === 'same') {
            this.addProductToCart({
              type: 'renew',
              quantity: 1,
              user: this.userInfos,
              amount: this.currentSubscription.price,
              subscription: this.currentSubscription
            }).then(
              function(success) {
                self.$swal({
                  toast: true,
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  type: 'success',
                  title: 'Renouvellement ajouté au panier'
                });
                self.$router.push({ name: 'CartPage' });
              },
              function(error) {
                self.$swal({
                  type: 'error',
                  title: "Impossible d'ajouter le renouvellement au panier",
                  text: error
                });
              }
            );
          }
          else {
            this.$router.push({ name: 'RenewPage' });
          }
        }
      },

      /**
       * Mettre à jour l'utilisateur
       **/
      async updateUserInfos(user) {
        await this.updateAccount(user).then(
          success => {
            this.$swal({
              toast: true,
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              type: 'success',
              title: 'Informations mises à jour'
            });
            this.updateUserInformations = false;
          },
          error => {
            this.$swal({
              type: 'error',
              title: 'Erreur',
              text: error,
              showCloseButton: true,
              confirmButtonText: 'Fermer'
            });
          }
        );
      }

    },
    watch: {

      /**
       * Afficher la souscription courante dès qu'on a reçu toutes les souscriptions
       * @param subs
       */
      subscriptions: function(subs) {
        this.currentSubscription = this._.find(subs, sub => {
          if (this._.isString(this.userInfos.subscription)) {
            return sub._id === this.userInfos.subscription;
          }
          else if (this.userInfos.subscription) {
            return sub._id === this.userInfos.subscription._id;
          }
        });
      }
    }
  };
</script>

<style scoped>
</style>
